// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1677":"958a43d4","2285":"958a43d4","5276":"18b1e733","6533":"7292fbb0"}[chunkId] + ".chunk.css";
};